import React from "react";

const Instagram = ({ data }) => {
	return (
		<>
			<div className="instagram-container cfc">
				{data.map((item, index) => {
					return (
						<div>
							<a
								title="View on Instagram"
								href={item.link}
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={item.img} alt={item.caption} title={item.caption} />
							</a>
						</div>
					);
				})}
			</div>

			<div className="instagram-button-container">
				<div className="valerolink leftbutton">
					<a
						href="https://www.instagram.com/vtochampions"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="fa fa-instagram" aria-hidden="true"></i>Follow on
						Instagram<i className="fa fa-angle-right"></i>
					</a>
				</div>
				<div style={{ marginLeft: "5px" }} className="valerolink leftbutton">
					<a
						href="https://www.facebook.com/VTOChampions"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="fa fa-facebook" aria-hidden="true"></i>Follow on
						Facebook<i className="fa fa-angle-right"></i>
					</a>
				</div>
			</div>

			<div style={{ marginRight: "5px" }}>
				<img
					style={{ width: "100%" }}
					src="https://valerotexasopen.com/assets/img/cfc-30-years-signature.jpg"
					alt="Celebrating 30 Years"
				/>
			</div>
		</>
	);
};
export default Instagram;
